// src/encounter/lib/foot-send-orders.ts
// The long page's closing-card foot draws Send orders (note-sign-actions.tsx) only for a non-nurse with a Wrap-up
// status slice. ONE rule, read by the foot (the button) and by the Wrap-up bar (which leaves its own Send orders out
// only when the foot has it), so the two can never drift apart (#765 review). Nurses keep Flutter's rule: no Send
// orders (`if (!b.isNurse)`). PURE.
import { sendOrdersLabel, sendOrdersState, type WrapUpSignLockProps, type WrapUpStatusProps } from '../wrap-up-actions-header';

export interface FootSendOrdersInput {
  status?: WrapUpStatusProps;
  signLock?: Pick<WrapUpSignLockProps, 'isNurse'>;
}

/** The foot's Send orders button, or undefined when the foot draws none (a nurse, or no Wrap-up status yet). */
export function footSendOrdersAction(
  wrapUp: FootSendOrdersInput | undefined,
): { label: string; disabled: boolean; title: string; onClick: () => void } | undefined {
  const status = wrapUp?.status;
  if (!status || wrapUp?.signLock?.isNurse) return undefined;
  return { ...sendOrdersState(status), label: sendOrdersLabel(status), onClick: status.onSendOrders };
}
